import { Toast } from "@capacitor/toast";
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { ReactNode, createContext, useCallback, useEffect, useState } from 'react';
import { db } from '../firebase-config';
import { consultaPagamentoPedido } from '../Utils/Services';
import { useStoreAccessState } from '../hooks/useStoreAccessState';
import { StoreAccess } from '../Utils/storeAccess';
import { DeliveryTerms } from '../Utils/deliveryAddressStorage';

type MessageContextProps = {
  children: ReactNode;
};

type MessageContextType = {

  storeAccess: StoreAccess;
  getActiveStoreId: () => string | null;
  storeLoading: boolean;
  storeError: string;
  selectMarketplaceStore: (id: string, deliveryTerms?: DeliveryTerms) => Promise<boolean>;
  clearActiveStore: () => void;
  retryStore: () => Promise<boolean>;

  esconderMenu: any;
  setEsconderMenu: (newState: any) => void;
  notificacoes: any;
  setNotificacoes: (newState: any) => void;
  pkCliente: any;
  setPkCliente: (newState: any) => void;
  loja: any;
  setLoja: (newState: any) => void;
  dadosEmpresa: any;
  setDadosEmpresa: (newState: any) => void;
  listaItemProdutos: any;
  setListaItemProdutos: (newState: any) => void;


  idPagamento: any;
  setIdPagamento: (newState: any) => void;

  isPaymentCompleted: any;
  setIsPaymentCompleted: (newState: any) => void;



  idPaymentSuccess: any;
  setIdPaymentSuccess: (newState: any) => void;


  // Toast functions for modal
  textToast: any;
  setTextToast: (newState: any) => void;
  showToast: any;
  setShowToast: (newState: any) => void;

  // Função para verificar pagamento
  verificarPagamentoPedido: (idPagamento: string) => () => void;
  
  // Função para parar verificação de pagamento
  pararVerificacaoPagamento: () => void;

};

export const MessageContext = createContext<MessageContextType>({} as MessageContextType);

export const MessageContextProvider = ({ children }: MessageContextProps) => {

  const [esconderMenu, setEsconderMenu] = useState<any>(false);
  const [notificacoes, setNotificacoes] = useState<any>([]);
  const [pkCliente, setPkCliente] = useState<any>();
  const [loja, setLoja] = useState<any>();
  const [dadosEmpresa, setCompany] = useState<any>(false);
  const [listaItemProdutos, setListaItemProdutos] = useState<any>([]);
  const storeState = useStoreAccessState(setCompany, setListaItemProdutos);
  const { getActiveStoreId } = storeState;
  const setDadosEmpresa = useCallback((update: any) => {
    setCompany((current: any) => {
      const next = typeof update === 'function' ? update(current) : update;
      return next?.pk && next.pk !== getActiveStoreId() ? current : next;
    });
  }, [getActiveStoreId]);

  const [idPagamento, setIdPagamento] = useState<any>(false);
  const [isPaymentCompleted, setIsPaymentCompleted] = useState<any>(false);


  const [idPaymentSuccess, setIdPaymentSuccess] = useState<any>();

  // Toast states for modal
  const [textToast, setTextToast] = useState<any>("");
  const [showToast, setShowToast] = useState<any>(false);

  // Estado para armazenar função de cleanup da verificação
  const [cleanupVerificacao, setCleanupVerificacao] = useState<(() => void) | null>(null);

  // Função para verificar pagamento
  const verificarPagamentoPedido = (idPagamento: string) => {
    let intervalId: any;
    let timeoutId: any;

    const verificarPagamento = async () => {
      try {



        
        // Usar fetch diretamente para ter controle total
        const url = consultaPagamentoPedido.url.replace("{id}", idPagamento);
        console.log("🔍 Fazendo requisição para:", url);
        
        const response = await fetch(url, {
          method: consultaPagamentoPedido.method,
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include'
        });
        
        console.log("📡 Status da resposta:", response.status);
        console.log("📡 Response ok:", response.ok);
        
        const responseText = await response.text();
        console.log("📡 Response text:", responseText);
        
        if (responseText === "pagou") {
          console.log("✅ PAGAMENTO CONFIRMADO! Finalizando...");
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          
          // Marca o pagamento como completado para acionar o fluxo
          setIsPaymentCompleted(true);
          
          Toast.show({
            text: "Pagamento realizado com sucesso.",
            position: "center",
            duration: "long"
          });
        } else {
          console.log("⏳ Pagamento ainda não confirmado. Response:", responseText);
        }
      } catch (error) {
        console.error('Erro ao verificar pagamento:', error);
      }
    };

    if (idPagamento) {
      intervalId = setInterval(verificarPagamento, 10000);
      timeoutId = setTimeout(() => {
        clearInterval(intervalId);
        console.log("Polling de pagamento parou após 6 minutos");
      }, 360000);
    }

    const cleanup = () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };

    // Armazena a função de cleanup
    setCleanupVerificacao(() => cleanup);

    return cleanup;
  };

  // Função para parar verificação de pagamento
  const pararVerificacaoPagamento = () => {
    if (cleanupVerificacao) {
      cleanupVerificacao();
      setCleanupVerificacao(null);
      console.log("Verificação de pagamento parada manualmente");
    }
  };

  //const [mensagens, setMensagens] = useState([{ mensagem: "Loading...", id: "initial" }]);
  useEffect(
    () => {

      console.log("cliente_context", pkCliente);
      if (pkCliente) {
        let consultaNotificacao = query(collection(db, "notificacoes"), where("pk", "==", pkCliente));

        let unsubscribeNotificacao = onSnapshot(consultaNotificacao, (snapshot) => {
          // console.log("recebeu notificacao", snapshot.docs.map((doc: any) => ({ ...doc.data(), id: doc.id })));
          setNotificacoes(snapshot.docs.map((doc: any) => ({ ...doc.data(), id: doc.id })))
        });


        return () => {
          unsubscribeNotificacao();
        }


      }
    },
    [pkCliente]
  );

  return (
    <MessageContext.Provider value={{
      ...storeState,
      esconderMenu,
      setEsconderMenu,
      notificacoes,
      setNotificacoes,
      pkCliente,
      setPkCliente,
      loja,
      setLoja,
      dadosEmpresa,
      setDadosEmpresa,
      listaItemProdutos,
      setListaItemProdutos,

      idPagamento,
      setIdPagamento,

      isPaymentCompleted,
      setIsPaymentCompleted,

      // qrCodePagamentoMaquininha,
      // setQrCodePagamentoMaquininha,

      idPaymentSuccess,
      setIdPaymentSuccess,

      // Toast functions
      textToast,
      setTextToast,
      showToast,
      setShowToast,

      // Função para verificar pagamento
      verificarPagamentoPedido,
      
      // Função para parar verificação de pagamento
      pararVerificacaoPagamento,
    }}
    >
      {children}
    </MessageContext.Provider>
  );
};
